import { QuotationTemplate } from "./quotation-template";
import { QuotationTemplateProduct } from "./quotation-template-product";

export class QuotationTemplateWithDetail {

    constructor(
        public template: QuotationTemplate,
        public productsToDelete: QuotationTemplateProduct[]
    ){}
}
